import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiFilledInput: Components<Theme>['MuiFilledInput'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.common.white,
      border: '1px solid #D4D8E3',
      borderRadius: '10px',
      '&::before, &::after': {
        display: 'none',
      },
      '&:hover': {
        backgroundColor: theme.palette.common.white,
        borderColor: '#939DB8',
      },
      '&.Mui-focused': {
        backgroundColor: theme.palette.common.white,
      },
      '&.Mui-disabled': {
        backgroundColor: '#EEEFF4',
        borderColor: '#EEEFF4',
        color: '#939DB8',
      },
      '&.Mui-error': {
        borderColor: theme.palette.error.contrastText,
      },
    }),
    input: ({ theme }) => ({
      backgroundColor: theme.palette.common.white,
      borderRadius: '10px',
      height: 'auto',
      '&:focus': {
        backgroundColor: theme.palette.common.white,
        borderRadius: '10px',
      },
      '&:-webkit-autofill': {
        backgroundColor: 'red !important',
        boxShadow: '0 0 0px 1000px white inset',
        webkitBoxShadow: '0 0 0px 1000px white inset',
      },
    }),
  },
};
